import { DefaultRenderingPipeline } from "@babylonjs/core/PostProcesses/";

export abstract class PipelineHelper {

  public static InitPipeline() {
    let pipeline = new DefaultRenderingPipeline('postProcess', false);

    // SMAA
    pipeline.samples = 8;

    // FXAA
    pipeline.fxaaEnabled = true;
    pipeline.fxaa.samples = 8;

    // Image processing
    pipeline.imageProcessingEnabled = true;
    pipeline.imageProcessing.contrast = 1.3;
    pipeline.imageProcessing.exposure = 1.2;
    pipeline.imageProcessing.toneMappingEnabled = false;
  }

}